import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import { findMatch } from '@/utils/resultsHelper';
import DropdownSegment from '@/components/DropdownSegment';
import { enabledIcon } from '@/constants/images';
import Fetch from '../hooks/fetch';
import Selectors from '../hooks/selectors';

const listItems = (templates, value, withIcon, intl) => templates.map((template) => ({
  key: `dataset_templates_${template.code}`,
  text: template.name,
  value: template.code,
  active: template.code === value,
  description: intl.formatMessage({ id: 'datasets.count' }, { total: template.metrics?.all_datasets }),
  icon: withIcon ? enabledIcon(template.enabled) : undefined,
  className: template.enabled ? undefined : 'warning',
}));

const CatalogueTemplatesDropdown = ({
  category,
  className,
  disabled,
  onChange,
  template,
  withDescription,
  withIcon,
}) => {
  const intl = useIntl();
  const { readStatus, templates } = Selectors.useCatalogueTemplatesDropdown({ category });
  Fetch.useFetchCatalogueTemplates({ category }, readStatus);
  const match = findMatch(templates, template) || templates[0];
  const description = match?.description;

  return (
    <>
      <Dropdown
        className={`aridhia-catalogue-templates-dropdown max-content ${className}`}
        options={listItems(templates, match?.code, withIcon, intl)}
        disabled={disabled}
        value={match?.code}
        fluid
        selection
        loading={readStatus === states.PENDING}
        placeholder={intl.formatMessage({ id: 'dataset.catalogue.template.placeholder' })}
        onChange={(e, { value }) => onChange(findMatch(templates, value))}
      />
      {withDescription && description && (
        <DropdownSegment className="aridhia-catalogue-templates-dropdown-segment" messageText={description} markdown />
      )}
    </>
  );
};

export default CatalogueTemplatesDropdown;
